module.exports = __webpack_public_path__ + "static/media/analytics_main_mo.877c0b44.png";